import { render } from "./LaborersDetail.vue?vue&type=template&id=38117fff&scoped=true"
import script from "./LaborersDetail.vue?vue&type=script&lang=js"
export * from "./LaborersDetail.vue?vue&type=script&lang=js"

import "./LaborersDetail.vue?vue&type=style&index=0&id=38117fff&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38117fff"],['__file',"src/views/h5/luqiao/laborers/laborers/LaborersDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38117fff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38117fff', __exports__)) {
    api.reload('38117fff', __exports__)
  }
  
  module.hot.accept("./LaborersDetail.vue?vue&type=template&id=38117fff&scoped=true", () => {
    api.rerender('38117fff', render)
  })

}


export default __exports__